import { ReactNode } from 'react';

interface ICardHeaderProps {
    children: ReactNode
    className?: string;
}

const CardHeader = ({ children, className }: ICardHeaderProps) => {
    return (
        <div className={`flex flex-wrap gap-[10px] bg-grayCard pt-[0.75rem] pb-[0.75rem] pl-[1.25rem] pr-[1.25rem] border-b-[1px] border-solid border-b-[#dedede] ${className ? className : ''}`}>
            {children}
        </div>
    )
}

export { CardHeader };